import { render, staticRenderFns } from "./PurchaseOrders.vue?vue&type=template&id=980b229a&scoped=true&"
import script from "./PurchaseOrders.vue?vue&type=script&lang=js&"
export * from "./PurchaseOrders.vue?vue&type=script&lang=js&"
import style0 from "./PurchaseOrders.vue?vue&type=style&index=0&id=980b229a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "980b229a",
  null
  
)

export default component.exports